import { render, staticRenderFns } from "./changeLang.vue?vue&type=template&id=01a53d81&scoped=true&"
import script from "./changeLang.vue?vue&type=script&lang=js&"
export * from "./changeLang.vue?vue&type=script&lang=js&"
import style0 from "./changeLang.vue?vue&type=style&index=0&id=01a53d81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a53d81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01a53d81')) {
      api.createRecord('01a53d81', component.options)
    } else {
      api.reload('01a53d81', component.options)
    }
    module.hot.accept("./changeLang.vue?vue&type=template&id=01a53d81&scoped=true&", function () {
      api.rerender('01a53d81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/components/changeLang.vue"
export default component.exports